import React from "react";

function CommunitySection() {
  return (
    <section className="py-16 md:py-24 relative bg-black">
      <div
        className="absolute inset-0 z-0"
        style={{
          background: "radial-gradient(circle at 30% 50%, rgba(157, 78, 221, 0.08) 0%, rgba(0, 0, 0, 0) 70%)",
        }}
      ></div>
      <div className="container relative z-10 mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-white mb-6">
              How Solcialize Keeps You Safe
            </h2>
            <ul className="space-y-4">
              <li className="flex items-start">
                <div className="bg-gradient-to-r from-[#FF4FBF]/20 to-[#5B5FFF]/20 rounded-full p-2 mr-4 mt-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9D4EDD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
                <div>
                  <span className="text-white font-medium">Link Detection</span>
                  <p className="text-gray-400 mt-1">All messages are automatically scanned and any links are disabled to prevent phishing attacks.</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="bg-gradient-to-r from-[#FF4FBF]/20 to-[#5B5FFF]/20 rounded-full p-2 mr-4 mt-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9D4EDD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
                <div>
                  <span className="text-white font-medium">Performance Verification</span>
                  <p className="text-gray-400 mt-1">Our leaderboard only shows traders with verified on-chain performance, not self-reported results.</p>
                </div>
              </li>
              <li className="flex items-start">
                <div className="bg-gradient-to-r from-[#FF4FBF]/20 to-[#5B5FFF]/20 rounded-full p-2 mr-4 mt-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9D4EDD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
                <div>
                  <span className="text-white font-medium">Limited Connections</span>
                  <p className="text-gray-400 mt-1">Quality over quantity - we limit friend connections to ensure meaningful interactions with top performers.</p>
                </div>
              </li>
            </ul>
          </div>
          <div className="bg-zinc-900/50 rounded-lg p-6 border border-zinc-800">
            <h3 className="text-xl font-medium mb-4 text-white">What Our Early Users Say</h3>
            <div className="space-y-6">
              <div className="border-l-2 border-[#9D4EDD] pl-4">
                <p className="text-gray-300 italic">
                  "This is the first ever decentralised social platform. A platform where I don't have to worry about privacy. I've connected with traders much better than me and learned so much."
                </p>
                <p className="text-gray-500 mt-2">— Amj6...e29f</p>
              </div>
              <div className="border-l-2 border-[#9D4EDD] pl-4">
                <p className="text-gray-300 italic">
                  "The anti-scam features are a game-changer. For the first time I feel safe discussing trading strategies with strangers."
                </p>
                <p className="text-gray-500 mt-2">— Hl7b...b12d</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CommunitySection;